import type { Context } from 'react';
import { createContext, useContext } from 'react';

import type { NavigationMap } from './typing';

const NavigationContext = createContext<NavigationMap<string, true>>({});

type NavigationHookArguments = {
    allowNavigationOptions: true;
};

export function useNavigation<Path extends string>(): NavigationMap<Path>;
export function useNavigation<Path extends string>(
    args: NavigationHookArguments,
): NavigationMap<Path, typeof args.allowNavigationOptions>;

export function useNavigation<Path extends string>(
    args?: NavigationHookArguments,
): NavigationMap<Path, true> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const allowNavigationOptions = args?.allowNavigationOptions;
    return useContext<NavigationMap<Path, typeof allowNavigationOptions>>(
        NavigationContext as unknown as Context<NavigationMap<Path, typeof allowNavigationOptions>>,
    );
}

export const NavigationProvider = NavigationContext.Provider;
